// 'version' is used in cypress.config.js. If you need to misplace it please update the file accordingly.
export const version = '1.2'
export const lastUpdated = 'September, 2024'
